import { Tag } from '@nimbus-ds/components';
import { ProductTransferListResponseDto } from '@tiendanube/common';
import { useTranslationCatalog } from 'domains/Catalog/hooks';
import { ICON_MAP, STATUS_MAP } from './util';

function TransferStatus({
  status,
}: Readonly<{ status: ProductTransferListResponseDto[number]['status'] }>) {
  const t = useTranslationCatalog('transfers.list');
  return (
    <Tag appearance={STATUS_MAP[status]}>
      {ICON_MAP[status]} {t(`status.${status}`)}
    </Tag>
  );
}

export default TransferStatus;
